import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Field } from "formik";
import CheckboxFormik from "app/pages/.shared/form/CheckboxFormik";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import IconTag from "app/pages/.shared/static/icons/IconTag";

const QuotationBoardFilterOptions = ({ availableBoards, setFieldValue, hideDiscountHBX }) => {
	return (
		<fieldset className="quotation-board-filter__options">
			<legend className="sr-only">
				<FormattedMessage id="quotation.board.filter.label" />
			</legend>

			<ul className="quotation-board-filter__options-list">
				{availableBoards.map(board => (
					<li key={board.boardCode} className="quotation-board-filter__option">
						<Field
							id={`board-filter-${board.boardCode}`}
							name="boards"
							component={CheckboxFormik}
							size={16}
							value={board.boardCode}
							grouped={true}
							className="quotation-board-filter__checkbox"
							onUpdate={value => {
								setFieldValue("boards", value);
							}}
						>
							<Typography
								variant={TYPOGRAPHY_VARIANTS.REGULAR}
								component="span"
								className="quotation-board-filter__option-label"
							>
								{board.label}
								{board.isDiscounted && !hideDiscountHBX && (
									<>
										<IconTag
											width={12}
											height={12}
											className="quotation-board-filter__discount-icon"
											aria-hidden="true"
										/>
										<span className="sr-only">
											<FormattedMessage id="quotation.board.discounted" />
										</span>
									</>
								)}
							</Typography>
						</Field>
					</li>
				))}
			</ul>
		</fieldset>
	);
};

QuotationBoardFilterOptions.propTypes = {
	availableBoards: PropTypes.arrayOf(
		PropTypes.shape({
			boardCode: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			isDiscounted: PropTypes.bool,
		})
	).isRequired,
	setFieldValue: PropTypes.func.isRequired,
	hideDiscountHBX: PropTypes.bool,
};

export default QuotationBoardFilterOptions;
